<template>
  <div class="col-md-12 instances_list">
    <div
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
            <span
                class="mdi"
                :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
                @click="toggleFiltersState"
            />
      <span class="main_fiters_toggler_text">
              {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
            </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="wrap_select">
        <div class="form_select">
          <fg-input
              v-model="filter.q"
              type="text"
              :placeholder="translate('search')"
              :clearable="true"
              @input="change_input"
          />
        </div>
      </div>

      <div class="wrap_select"></div>
      <div class="wrap_select"></div>
      <div class="wrap_select"></div>
      <div class="wrap_select"></div>
      <div class="wrap_select"></div>
    </div>

    <div class="response_table">
      <div class="loading" v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>
      <table v-else>
        <thead>
          <tr>
            <th scope="col" >
              {{ translate('server.instance_list.name') }}
            </th>
            <th scope="col" class="text-right" >
              {{ translate('server.instance_list.port') }}
            </th>
            <th scope="col" >
              {{ translate('server.instance_list.server_name') }}
            </th>
            <th scope="col" >
              {{ translate('server.instance_list.server_name_short') }}
            </th>
            <th scope="col" >
              {{ translate('server.instance_list.group_name') }}
            </th>
            <th scope="col" >
              {{ translate('server.instance_list.ip') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(instance,key) in instance_list"
              :key="key">
            <td :data-label="translate('server.instance_list.name')">
              {{ instance.name }}
            </td>
            <td class="text-right" :data-label="translate('server.instance_list.port')">
              {{ instance.port }}
            </td>
            <td :data-label="translate('server.instance_list.server_name')">
              {{ instance.server_name }}
            </td>
            <td :data-label="translate('server.instance_list.server_name_short')">
              {{ instance.server_name_short }}
            </td>
            <td :data-label="translate('server.instance_list.group_name')">
              {{ instance.server_instance_group_name }}
            </td>
            <td :data-label="translate('server.instance_list.ip')">
              {{ instance.server_ip }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import ServerItem from "../ServerList/Item/Index.vue";

export default {
  name: 'InstanceList',
  components: {
    ServerItem
  },
  props: {
    active: Boolean,
    groups_instances: Array
  },
  data () {
    return {
      instances: [],
      filter:{
        q: ""
      },
      loading: false,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  created() {
    this.get_instances()
  },

  activated() {
    this.get_instances()
  },

  computed:{
    instance_list(){
      return this.instances.sort(this.compareNumbers);
    },
    send_filter(){
      let filter = {}
      Object.keys(this.filter).forEach((item) => {
        this.filter[item] !== null && this.filter[item] !== "" && this.filter[item] !== undefined ? filter[item] = this.filter[item] : ""
      })
      return filter
    }
  },

  methods: {
    change_input() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.get_instances, 500);
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'q':
              this.filter[key] = this.$route.query[key]
              break;
          }
        }
      }
    },
    get_instances(){
      this.loading = true
      this.$http.v1.getServerInstanceList(this.send_filter, (response) => {
        this.instances = response.data
        this.loading = false
      })
    },
    toggleFiltersState() {
      this.filters_state = !this.filters_state;
      this.localStorage.setItem("filters_state", this.filters_state);
    },
  }
}
</script>

<style lang="scss" scoped>
  .instances_list{
    height: 100%;
    padding-top: 30px;
    display: flex;
    flex-direction: column;

    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      & > *{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
      .filter{
        margin: 0;
      }
      .form{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 2;

        .btn{
          width: 30%;
        }
      }
      .wrap_select{
        width: 100%;
        flex-direction: column;
        .form_select{
          width: 100%;
          margin-bottom: 10px;
          &:last-child{
            margin-bottom: 0;
          }
        }
        .vue-treeselect{
          margin-bottom: 0;
        }
        .form-group{
          margin: 0;
        }
      }
    }

    .loading {
      background-color: #fff;
      height: calc(100% - 80px);
      width: calc(100% - 30px);
    }

    .response_table{
      flex: 10;
      padding: 0 0 1px;
      th, td{
        font-size: 12px;
        text-align: left;
        &.text-right{
          text-align: right;
        }
      }
    }
  }

</style>
